export const phoneFormats = {
  AC: 'xxxx',
  AD: 'xxx-xxx',
  AE: 'xxx-xxxx',
  AF: 'xx-xxx-xxxx',
  AG: '268 xxx-xxxx',
  AI: '264 xxx-xxxx',
  AL: '(xxx) xxx-xxx',
  AM: 'xx-xxx-xxx',
  AN: 'xxx-xxxx',
  AO: '(xxx) xxx-xxx',
  AQ: '1xx-xxx',
  AR: '(xxx) xxx-xxxx',
  AS: '684 xxx-xxxx',
  AT: '(xxx) xxx-xxxx',
  AU: 'x-xxxx-xxxx',
  AW: 'xxx-xxxx',
  AZ: 'xx-xxx-xx-xx',
  BA: 'xx-xxxxx',
  BB: '246 xxx-xxxx',
  BD: 'xx-xxx-xxx',
  BE: '(xxx) xxx-xxx',
  BF: 'xx-xx-xxxx',
  BG: '(xxx) xxx-xxx',
  BH: 'xxxx-xxxx',
  BI: 'xx-xx-xxxx',
  BJ: 'xx-xx-xxxx',
  BM: '441 xxx-xxxx',
  BN: 'xxx-xxxx',
  BO: 'x-xxx-xxxx',
  BR: '(xx) xxxxx-xxxx',
  BS: '242 xxx-xxxx',
  BT: '17-xxx-xxx',
  BW: 'xx-xxx-xxx',
  BY: 'xx xxx-xx-xx',
  BZ: 'xxx-xxxx',
  CA: 'xxx xxx-xxxx',
  CD: '(xxx) xxx-xxx',
  CF: 'xx-xx-xxxx',
  CG: 'xx-xxx-xxxx',
  CH: 'xx-xxx-xxxx',
  CI: 'xx-xxx-xxx',
  CK: 'xx-xxx',
  CL: 'x-xxxx-xxxx',
  CM: 'xxxx-xxxx',
  CN: 'xxx xxxx-xxxx',
  CO: 'xxx xxx-xxxx',
  CR: 'xxxx-xxxx',
  CU: 'x-xxx-xxxx',
  CV: 'xxx xx-xx',
  CY: 'xx-xxx-xxx',
  CZ: 'xxx xxx-xxx',
  DE: 'xxx xxx-xxxx',
  DJ: 'xx-xx-xx-xx',
  DK: 'xx-xx-xx-xx',
  DM: '767 xxx-xxxx',
  DO: '809 xxx-xxxx',
  DZ: 'xx-xxx-xxxx',
  EC: 'xx-xxx-xxxx',
  EE: 'xxxx-xxxx',
  EG: 'xxx xxx-xxxx',
  ER: 'x-xxx-xxx',
  ES: 'xxx xxx-xxx',
  ET: 'xx-xxx-xxxx',
  FI: 'xxx xxx-xx-xx',
  FJ: 'xx-xxxxx',
  FM: 'xxx-xxxx',
  FO: 'xxx-xxx',
  FR: 'xxx xxx-xxx',
  GA: 'x-xx-xx-xx',
  GD: '473 xxx-xxxx',
  GE: 'xxx xxx-xxx',
  GF: 'xxxxx-xxxx',
  GH: 'xxx xxx-xxx',
  GI: 'xxx-xxxxx',
  GL: 'xx-xx-xx',
  GM: 'xxx xx-xx',
  GN: 'xx-xxx-xxx',
  GQ: 'xx-xxx-xxxx',
  GR: 'xxx xxx-xxxx',
  GT: 'x-xxx-xxxx',
  GU: '671 xxx-xxxx',
  GW: 'x-xxxxxx',
  GY: 'xxx-xxxx',
  HK: 'xxxx-xxxx',
  HN: 'xxxx-xxxx',
  HR: 'xx-xxx-xxx',
  HT: 'xx-xx-xxxx',
  HU: 'xxx xxx-xxx',
  ID: '8xx xxx-xxxx',
  IE: 'xxx xxx-xxx',
  IL: 'x-xxx-xxxx',
  IN: 'xxxx xxx-xxx',
  IQ: 'xxx xxx-xxxx',
  IR: 'xxx xxx-xxxx',
  IS: 'xxx-xxxx',
  IT: 'xxx xxxx-xxx',
  JM: '876 xxx-xxxx',
  JO: 'x-xxxx-xxxx',
  JP: 'xx-xxxx-xxxx',
  KE: 'xxx-xxxxxx',
  KH: 'xx-xxx-xxx',
  KM: 'xx-xxxxx',
  KN: '869 xxx-xxxx',
  KR: 'xx-xxx-xxxx',
  KW: 'xxxx-xxxx',
  KZ: '7xx xxx-xx-xx',
  LA: '20xx xxx-xxx',
  LB: 'xx-xxx-xxx',
  LC: '758 xxx-xxxx',
  LI: 'xxx xxx-xxxx',
  LK: 'xx-xxx-xxxx',
  LT: 'xxx xx-xxx',
  LU: 'xxx xxx-xxx',
  LV: 'xx-xxx-xxx',
  LY: 'xx-xxx-xxx',
  MA: 'xx-xxxx-xxx',
  MC: 'xxx xxx-xxx',
  MD: 'xxxx-xxxx',
  ME: 'xx-xxx-xxx',
  MG: 'xx-xx-xxxxx',
  MH: 'xxx-xxxx',
  MK: 'xx-xxx-xxx',
  ML: 'xx-xx-xxxx',
  MM: 'xx-xxx-xxx',
  MN: 'xx-xx-xxxx',
  MO: 'xxxx-xxxx',
  MP: '670 xxx-xxxx',
  MQ: 'xxx xx-xx-xx',
  MT: 'xxxx-xxxx',
  MU: 'xxx-xxxx',
  MV: 'xxx-xxxx',
  MW: '1-xxx-xxx',
  MX: 'xxx xxx-xxxx',
  MY: 'xxx xxx-xxx',
  MZ: 'xx-xxx-xxx',
  NA: 'xx-xxx-xxxx',
  NC: 'xx-xxxx',
  NE: 'xx-xx-xxxx',
  NG: 'xxx xxx-xxxx',
  NI: 'xxxx-xxxx',
  NL: 'xx-xxx-xxxx',
  NO: 'xxx xx-xxx',
  NP: 'xx-xxx-xxx',
  NR: 'xxx-xxxx',
  NZ: 'xxx xxx-xxx',
  OM: 'xx-xxx-xxx',
  PA: 'xxx-xxxx',
  PE: 'xxx xxx-xxx',
  PH: 'xxx xxx-xxxx',
  PK: 'xxx xxxx-xxx',
  PL: 'xxx xxx-xxx',
  PT: 'xxx xxx-xxx',
  PW: 'xxx-xxxx',
  PY: 'xxx xxx-xxx',
  QA: 'xxx-xxxx',
  RE: 'xxxxx-xxxx',
  RO: 'xxx xxx-xxx',
  RS: 'xxx xxx-xxxx',
  RU: 'xxx xxx-xx-xx',
  RW: 'xxx xxx-xxx',
  SA: 'xx-xxx-xxxx',
  SB: 'xx-xxxxx',
  SC: 'xxx-xxxx',
  SE: 'xx-xxx-xxx',
  SG: 'xxxx-xxxx',
  SI: 'xxx xxx-xxx',
  SK: 'xxx xxx-xxx',
  SN: 'xx-xxx-xxxx',
  SO: 'xx-xxx-xxx',
  SR: 'xxx-xxxx',
  ST: 'xx-xxx',
  SV: 'xxx xxx-xxxx',
  SY: 'xx-xxx-xxx',
  SZ: 'xx-xxx-xxx',
  TC: '649 xxx-xxxx',
  TD: 'xx-xxx-xxx',
  TH: 'xxx xxx-xxxx',
  TL: 'xx-xxx-xxxx',
  TM: 'xx-xx-xxxx',
  TN: 'xx-xxx-xxx',
  TO: 'xxx-xxxx',
  TR: 'xxx xxx-xxxx',
  TT: '868 xxx-xxxx',
  TV: 'xx-xxx',
  TZ: 'xx-xxx-xxxx',
  UA: 'xxx xxx-xxxx',
  UG: 'xxx xxx-xxx',
  US: 'xxx xxx-xxxx',
  UY: 'xxx xxx-xxx',
  UZ: 'xxx xxx-xx-xx',
  VC: '784 xxx-xxxx',
  VE: 'xxx xxx-xxxx',
  VN: 'xx-xxx-xxx',
  VU: 'xx-xxxxx',
  WF: 'xx-xxx',
  WS: '685 xxx-xxxx',
  YE: 'xx-xxx-xxx',
  YT: 'xxxx-xxxx',
  ZA: 'xx-xxx-xxxx',
  ZM: 'xxx-xxxxx',
  ZW: 'xx-xxx-xxxx',
};

export function getPhoneFormatByCountryCode(countryCode: string) {
  return phoneFormats[countryCode.toUpperCase()];
}
